<template>
  <div class="o-card l-account__form">
    <form @submit="TO_SIGN_IN">
      <div class="u-margin-bottom">
        <logo width="80"></logo>
        <h6 class="u-margin-top u-color-primary">
          {{ $t("common.welcome") }},
        </h6>
        <h4>
          {{ getAppSettings.projectName }}
          {{ $t(`loginOf${signInType !== "user" ? "Admin" : "User"}`) }}
        </h4>
        <p class="u-font-size-small">
          <small> {{ $t("account.signIn.description") }}.. </small>
        </p>
      </div>
      <div
        v-if="!signInType"
        class="btn-group-container u-justify-content-flex-end u-margin-bottom-small"
      >
        <Button
          group-item
          block
          :variant="`${loginType === 'admin' ? '' : 'light-'}${
            loginType === 'admin' ? 'primary' : 'primary'
          }`"
          @click="loginType = 'admin'"
        >
          {{ $t("loginType.admin") }}
        </Button>
        <Button
          group-item
          block
          @click="loginType = 'user'"
          :variant="`${loginType !== 'admin' ? '' : 'light-'}${
            loginType === 'admin' ? 'primary' : 'primary'
          }`"
        >
          {{ $t("loginType.user") }}
        </Button>
      </div>
      <div v-if="localStorageEmail" class="">
        <div
          class="u-display-flex u-align-items-center u-padding-xsmall u-border u-radius-g"
        >
          <i class="icofont-email u-font-size-large"></i>
          <span class="u-margin-left-small">{{ localStorageEmail }}</span>
        </div>
        <div class="u-text-align-right">
          <a @click="CHANGE_EMAIL()" href="javascript:void(0)">
            <small>
              <i> {{ $t("account.signIn.changeEmail") }}</i>
            </small>
          </a>
        </div>
      </div>
      <BaseInput
        v-else
        mandatory
        :label="$t('account.signIn.email')"
        type="email"
        input-id="email"
        icon="email"
        :placeholder="$t('account.signIn.emailPlaceholder')"
        block
        v-model="form.email"
      />
      <BaseInput
        mandatory
        minlength="3"
        :label="$t('account.signIn.password')"
        icon="ui-lock"
        :placeholder="$t('account.signIn.passwordPlaceholder')"
        maxlength="25"
        block
        v-model="form.password"
        type="password"
      />
      <router-link :to="{ name: 'forget-password' }">
        <div class="u-text-align-right">
          <small>
            <i> {{ $t("account.signIn.forgotPassword") }}</i>
          </small>
        </div>
      </router-link>
      <Button
        class="u-margin-top"
        :loading="getLoadingStatus"
        block
        variant="primary"
        type="submit"
      >
        {{ $t("account.signIn.button") }}
      </Button>
    </form>
    <div class="u-text-align-center u-margin-top" v-if="signInType">
      <router-link
        :to="{ name: `sign-in${signInType === 'user' ? '' : '-user'}` }"
      >
        <small>
          {{ $t(`loginOf${signInType === "user" ? "Admin" : "User"}`) }}
          <i class="icofont-arrow-right"></i>
        </small>
      </router-link>
    </div>
  </div>
</template>

<script>
import BaseInput from "@base/Inputs/BaseInput.vue";
import Button from "@base/Button.vue";
import GeneralStore from "../../mixins/generalStore";
import { mapGetters } from "vuex";
import Logo from "../Shared/Sidebar/Logo.vue";
export default {
  mixins: [GeneralStore],
  props: {
    signInType: {
      default: "",
    },
  },
  components: {
    BaseInput,
    Button,
    Logo,
  },
  computed: {
    ...mapGetters(["getAppSettings"]),
  },
  data() {
    return {
      localStorageEmail: null,
      form: {
        email: "",
        password: "",
      },
      loginType: "admin",
    };
  },
  methods: {
    getEmailFromLocalstorage() {
      const email = localStorage.getItem("email") || null;
      if (email) this.form.email = email;
      return email;
    },
    CHANGE_EMAIL() {
      localStorage.removeItem("email");
      this.localStorageEmail = null;
      this.form.email = "";
      document.getElementById("email").focus();
    },
    TO_SIGN_IN(e) {
      e.preventDefault();
      this.$store.dispatch("TO_SIGN_IN", {
        ...this.form,
        loginType: this.signInType || this.loginType,
      });
    },
  },
  created() {
    this.storeNamespace = "account";
    this.localStorageEmail = this.getEmailFromLocalstorage();
  },
};
</script>

<style></style>
